import { ObjectPath } from "./objectpath";
export function property(name) {
    var actions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        actions[_i - 1] = arguments[_i];
    }
    return new ObjectPath("<Property Id=\"$$ID$$\" ParentId=\"$$PARENT_ID$$\" Name=\"" + name + "\" />", actions);
}
export function staticMethod(name, typeId) {
    var actions = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        actions[_i - 2] = arguments[_i];
    }
    return new ObjectPath("<StaticMethod Id=\"$$ID$$\" Name=\"" + name + "\" TypeId=\"" + typeId + "\" />", actions);
}
export function staticProperty(name, typeId) {
    var actions = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        actions[_i - 2] = arguments[_i];
    }
    return new ObjectPath("<StaticProperty Id=\"$$ID$$\" Name=\"" + name + "\" TypeId=\"" + typeId + "\" />", actions);
}
export function objConstructor(typeId) {
    var actions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        actions[_i - 1] = arguments[_i];
    }
    return new ObjectPath("<Constructor Id=\"$$ID$$\" TypeId=\"" + typeId + "\" />", actions);
}
/**
 * Used to build parameters when calling methods
 */
var MethodParams = /** @class */ (function () {
    function MethodParams(_p) {
        if (_p === void 0) { _p = []; }
        this._p = _p;
    }
    MethodParams.build = function (initValues) {
        if (initValues === void 0) { initValues = []; }
        var params = new MethodParams();
        [].push.apply(params._p, initValues);
        return params;
    };
    MethodParams.prototype.string = function (value) {
        return this.a("String", value);
    };
    MethodParams.prototype.number = function (value) {
        return this.a("Number", value.toString());
    };
    MethodParams.prototype.boolean = function (value) {
        return this.a("Boolean", value.toString());
    };
    MethodParams.prototype.strArray = function (values) {
        return this.a("Array", values.map(function (v) { return "<Object Type=\"String\">" + v + "</Object>"; }).join(""));
    };
    MethodParams.prototype.objectPath = function (inputIndex) {
        return this.a("ObjectPath", inputIndex.toString());
    };
    MethodParams.prototype.toArray = function () {
        return this._p;
    };
    MethodParams.prototype.a = function (type, value) {
        value = value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
        this._p.push({ type: type, value: value });
        return this;
    };
    return MethodParams;
}());
export { MethodParams };
export function method(name, params) {
    var actions = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        actions[_i - 2] = arguments[_i];
    }
    var builder = [];
    builder.push("<Method Id=\"$$ID$$\" ParentId=\"$$PARENT_ID$$\" Name=\"" + name + "\">");
    if (params !== null) {
        var arrParams = params.toArray();
        if (arrParams.length < 1) {
            builder.push("<Parameters />");
        }
        else {
            builder.push("<Parameters>");
            [].push.apply(builder, arrParams.map(function (p) {
                if (p.type === "ObjectPath") {
                    return "<Parameter ObjectPathId=\"$$OP_PARAM_ID_" + p.value + "$$\" />";
                }
                return "<Parameter Type=\"" + p.type + "\">" + p.value + "</Parameter>";
            }));
            builder.push("</Parameters>");
        }
    }
    builder.push("</Method>");
    return new ObjectPath(builder.join(""), actions);
}
//# sourceMappingURL=opbuilders.js.map